<script>
import { mapActions, mapState } from 'vuex';
import bem from '@/utils/bem';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import { ArrowLeftOutlined } from '@ant-design/icons-vue';
import pageUrls from '@/router/pageUrls';

const { companiesPage } = pageUrls;
const b = bem('company-page');

export default {
  components: {
    PageHeader,
    ArrowLeftOutlined,
  },
  data() {
    return {
      companyId: null,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getCompanyAction: 'companies/getCompany',
    }),
    async loadCompany() {
      await this.getCompanyAction(this.companyId);
    },
    navigateBack() {
      this.$router.push(companiesPage);
    },
  },
  async mounted() {
    this.companyId = this.$route.params.id;
    await this.loadCompany();
    // Redirect to page-content as default tab
    this.$router.replace(`${companiesPage}/${this.companyId}/page-content`);
  },
  computed: {
    ...mapState({
      currentCompany: (state) => state.companies.currentCompany,
      isCurrentCompanyLoaded: (state) => state.companies.isCurrentCompanyLoaded,
    }),
  },
};
</script>

<template>
  <PageHeader title="POD Details">
    <template #extra>
      <a-button @click="navigateBack">
        <ArrowLeftOutlined /> Back to PODs
      </a-button>
    </template>
  </PageHeader>

  <div :class="b()">
    <a-spin :spinning="!isCurrentCompanyLoaded">
      <div :class="b('content')">
        <div :class="b('header')">
          <span :class="b('label')">POD ></span>
          <span :class="b('name')">{{ currentCompany?.displayName }}</span>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<style scoped lang="scss">
.company-page {
  margin: 0 20px;

  &__content {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    min-height: 200px;
  }

  &__header {
    display: flex;
    align-items: baseline;
    gap: 8px;
  }

  &__label {
    color: var(--light-gray, #7F7F7F);
    font-family: Montserrat;
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  &__name {
    color: var(--Dark, #293241);
    font-family: Montserrat;
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
  }
}
</style>
